import { apiSlice } from "../api/apiSlice";

export const videoApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query({
      query: () => "/videos",
    }),
    addVideo: builder.mutation({
      query: (body) => ({
        url: "/videos",
        method: "POST",
        body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled;
          if (res.data) {
            dispatch(
              apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
                draft.push(res.data);
              })
            );
          }
        } catch (error) {
          console.log(error);
        }
      },
    }),
    deleteVideo: builder.mutation({
      query: (id) => ({
        url: `/videos/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
            return draft.filter((item) => item.id !== id);
          })
        );

        try {
          await queryFulfilled;
        } catch (error) {
          pathResult.undo();
        }
      },
    }),
    editVideo: builder.mutation({
      query: (body) => ({
        url: `/videos/${body.id}`,
        method: "PATCH",
        body,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const response = await queryFulfilled;

        if (response?.data?.id) {
          dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              let indexToUpdate = draft.findIndex(
                (task) => task.id == arg.id.toString()
              );
              if (indexToUpdate !== -1) {
                draft[indexToUpdate] = response.data;
              }
            })
          );

          dispatch(
            apiSlice.util.updateQueryData(
              "getVideo",
              arg.id.toString(),
              (draft) => {
                Object.assign(draft, response.data);
              }
            )
          );
        }
      },
    }),
    getVideo: builder.query({
      query: (id) => `/videos/${id}`,
    }),
  }),
});

export const {
  useGetVideosQuery,
  useAddVideoMutation,
  useDeleteVideoMutation,
  useEditVideoMutation,
  useGetVideoQuery,
} = videoApi;
